/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PaginatedSellerOrgContactListList } from '../model';
// @ts-ignore
import { SellerBookingDataRequest } from '../model';
// @ts-ignore
import { SellerDataRequestCreate } from '../model';
// @ts-ignore
import { SellerDataRequestRead } from '../model';
/**
 * SellerBookingDataRequestApi - axios parameter creator
 * @export
 */
export const SellerBookingDataRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * A User can send an Org a Booking Request if they are a valid PENDING or APPROVED Contact of the Organisation.
         * @summary List of Organisations the User can send a Data Request to.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CT' | 'GT' | 'SH'} [product] Product id
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [states] Filter by state(s), eg. ?states&#x3D;WA,QLD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgList: async (page?: number, pageSize?: number, product?: 'CT' | 'GT' | 'SH', states?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/booking/data-request/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Booking Data Request to Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {SellerDataRequestCreate} sellerDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgProductCreate: async (orgId: string, productId: string, sellerDataRequestCreate: SellerDataRequestCreate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('sellerBookingDataRequestOrgProductCreate', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('sellerBookingDataRequestOrgProductCreate', 'productId', productId)
            // verify required parameter 'sellerDataRequestCreate' is not null or undefined
            assertParamExists('sellerBookingDataRequestOrgProductCreate', 'sellerDataRequestCreate', sellerDataRequestCreate)
            const localVarPath = `/v2/seller/booking/data-request/org/{org_id}/product/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sellerDataRequestCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load the Product setup for sending a Data Request to the Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgProductRetrieve: async (orgId: string, productId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('sellerBookingDataRequestOrgProductRetrieve', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('sellerBookingDataRequestOrgProductRetrieve', 'productId', productId)
            const localVarPath = `/v2/seller/booking/data-request/org/{org_id}/product/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerBookingDataRequestApi - functional programming interface
 * @export
 */
export const SellerBookingDataRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerBookingDataRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * A User can send an Org a Booking Request if they are a valid PENDING or APPROVED Contact of the Organisation.
         * @summary List of Organisations the User can send a Data Request to.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CT' | 'GT' | 'SH'} [product] Product id
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [states] Filter by state(s), eg. ?states&#x3D;WA,QLD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerBookingDataRequestOrgList(page?: number, pageSize?: number, product?: 'CT' | 'GT' | 'SH', states?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSellerOrgContactListList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerBookingDataRequestOrgList(page, pageSize, product, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Booking Data Request to Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {SellerDataRequestCreate} sellerDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerBookingDataRequestOrgProductCreate(orgId: string, productId: string, sellerDataRequestCreate: SellerDataRequestCreate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerBookingDataRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerBookingDataRequestOrgProductCreate(orgId, productId, sellerDataRequestCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Load the Product setup for sending a Data Request to the Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerBookingDataRequestOrgProductRetrieve(orgId: string, productId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SellerDataRequestRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerBookingDataRequestOrgProductRetrieve(orgId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerBookingDataRequestApi - factory interface
 * @export
 */
export const SellerBookingDataRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerBookingDataRequestApiFp(configuration)
    return {
        /**
         * A User can send an Org a Booking Request if they are a valid PENDING or APPROVED Contact of the Organisation.
         * @summary List of Organisations the User can send a Data Request to.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {'CT' | 'GT' | 'SH'} [product] Product id
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [states] Filter by state(s), eg. ?states&#x3D;WA,QLD
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgList(page?: number, pageSize?: number, product?: 'CT' | 'GT' | 'SH', states?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', options?: any): AxiosPromise<PaginatedSellerOrgContactListList> {
            return localVarFp.sellerBookingDataRequestOrgList(page, pageSize, product, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Booking Data Request to Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {SellerDataRequestCreate} sellerDataRequestCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgProductCreate(orgId: string, productId: string, sellerDataRequestCreate: SellerDataRequestCreate, options?: any): AxiosPromise<SellerBookingDataRequest> {
            return localVarFp.sellerBookingDataRequestOrgProductCreate(orgId, productId, sellerDataRequestCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load the Product setup for sending a Data Request to the Org
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerBookingDataRequestOrgProductRetrieve(orgId: string, productId: string, options?: any): AxiosPromise<SellerDataRequestRead> {
            return localVarFp.sellerBookingDataRequestOrgProductRetrieve(orgId, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerBookingDataRequestOrgList operation in SellerBookingDataRequestApi.
 * @export
 * @interface SellerBookingDataRequestApiSellerBookingDataRequestOrgListRequest
 */
export interface SellerBookingDataRequestApiSellerBookingDataRequestOrgListRequest {
    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgList
     */
    readonly pageSize?: number

    /**
     * Product id
     * @type {'CT' | 'GT' | 'SH'}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgList
     */
    readonly product?: 'CT' | 'GT' | 'SH'

    /**
     * Filter by state(s), eg. ?states&#x3D;WA,QLD
     * @type {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgList
     */
    readonly states?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'
}

/**
 * Request parameters for sellerBookingDataRequestOrgProductCreate operation in SellerBookingDataRequestApi.
 * @export
 * @interface SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreateRequest
 */
export interface SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreate
     */
    readonly orgId: string

    /**
     * 
     * @type {string}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreate
     */
    readonly productId: string

    /**
     * 
     * @type {SellerDataRequestCreate}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreate
     */
    readonly sellerDataRequestCreate: SellerDataRequestCreate
}

/**
 * Request parameters for sellerBookingDataRequestOrgProductRetrieve operation in SellerBookingDataRequestApi.
 * @export
 * @interface SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieveRequest
 */
export interface SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieve
     */
    readonly orgId: string

    /**
     * 
     * @type {string}
     * @memberof SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieve
     */
    readonly productId: string
}

/**
 * SellerBookingDataRequestApi - object-oriented interface
 * @export
 * @class SellerBookingDataRequestApi
 * @extends {BaseAPI}
 */
export class SellerBookingDataRequestApi extends BaseAPI {
    /**
     * A User can send an Org a Booking Request if they are a valid PENDING or APPROVED Contact of the Organisation.
     * @summary List of Organisations the User can send a Data Request to.
     * @param {SellerBookingDataRequestApiSellerBookingDataRequestOrgListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerBookingDataRequestApi
     */
    public sellerBookingDataRequestOrgList(requestParameters: SellerBookingDataRequestApiSellerBookingDataRequestOrgListRequest = {}, options?: any) {
        return SellerBookingDataRequestApiFp(this.configuration).sellerBookingDataRequestOrgList(requestParameters.page, requestParameters.pageSize, requestParameters.product, requestParameters.states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Booking Data Request to Org
     * @param {SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerBookingDataRequestApi
     */
    public sellerBookingDataRequestOrgProductCreate(requestParameters: SellerBookingDataRequestApiSellerBookingDataRequestOrgProductCreateRequest, options?: any) {
        return SellerBookingDataRequestApiFp(this.configuration).sellerBookingDataRequestOrgProductCreate(requestParameters.orgId, requestParameters.productId, requestParameters.sellerDataRequestCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load the Product setup for sending a Data Request to the Org
     * @param {SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerBookingDataRequestApi
     */
    public sellerBookingDataRequestOrgProductRetrieve(requestParameters: SellerBookingDataRequestApiSellerBookingDataRequestOrgProductRetrieveRequest, options?: any) {
        return SellerBookingDataRequestApiFp(this.configuration).sellerBookingDataRequestOrgProductRetrieve(requestParameters.orgId, requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
}
